import React, { useEffect, useContext } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';
import LayoutDesktop from './LayoutDesktop';
import LayoutMobile from './LayoutMobile';
import { getUserInfo } from '../apiCalls/user_profile/api_v1_profile';
import { AuthContext } from '../apiCalls/jwt/AuthContext';
import { setStoredSkillLevel } from '../components/ui/GaPrimitives';

const Layout = ({ children }) => {
  const isDesktop = useMediaQuery('(min-width:900px)');
  const { auth } = useContext(AuthContext);
  const location = useLocation();
  const isIntro = location.pathname.startsWith('/intro');
  
  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await getUserInfo();
        if (response.status === 200) {
          setStoredSkillLevel(response.data.skill_level.toLowerCase());
          sessionStorage.setItem('last_played_level', response.data.latest_played_level);
        }
      } catch (error) {
        setStoredSkillLevel('beginner');
      }
    };

    if (auth.accessToken) {
      fetchUserInfo();
    }
  }, [auth.accessToken]);

  if (isIntro) {
    // Page shell locks document scroll; intro needs its own scroll area.
    return (
      <Box sx={{ height: "100%", overflow: "auto", bgcolor: "#0D0F0A" }}>
        {children}
      </Box>
    );
  }

  return (
    <>
      {isDesktop ? (
        <LayoutDesktop>{children}</LayoutDesktop>
      ) : (
        <LayoutMobile>{children}</LayoutMobile>
      )}
    </>
  );
};

export default Layout;